const arrendamientosTipo = {
  path: "arrendamientos",
  name: 'arrendamientos',
  redirect: {
    name: 'arrendamientos-index'
  },
  component: () =>
    import(
      /* webpackChunkName: 'Dashboard-Arrendamientos-Root' */ "@/modules/dashboard/pages/arrendamientos"
    ),
  children: [
    {
      path: "",
      name: "arrendamientos-index",
      component: () =>
        import(
          /* webpackChunkName: 'Dashboard-Arrendamientos' */ "@/modules/dashboard/pages/arrendamientos/ArrendamientosPage"
        ),
    },
    {
      path: ':arrendamiento_id/detalle',
      name: 'arrendamientos-detalle',
      component: () => 
      import(
        /* webpackChunkName: 'Dashboard-Arrendamientos-Detalle' */ "@/modules/dashboard/pages/arrendamientos/ArrendamientosDetallePage"
      )
    }
  ],
};

export default arrendamientosTipo;
